import React from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import { themableImagePath } from '../utils/imageUtils';
import ModalFooter from './ModalFooter';

function OverlapWarning({ overlapElements, onCancel, onConfirm, confirmDisabled }) {
    const { t } = useLingui();

    return (
        <>
            <div className="grow bg-white py-4 px-2 sm:px-4">
                <div className="bg-grey-lighter py-4 px-2 sm:px-4">
                    <div className="flex items-center text-2xl mb-4 uppercase">
                        <img alt="" className="w-6 h-6 mr-2" src={themableImagePath('infoicon_inverted.svg')} />
                        <span><Trans id="overlapping_planner_items_title">Overlapping Planner Items</Trans></span>
                    </div>
                    <div>
                        <Trans id="overlapping_planner_items_desc">If you add this item to planner, there will be an overlap with the following planner items:</Trans>
                    </div>
                    <div className="mt-4">
                        {overlapElements.map((overlap, index) =>
                            <div key={index} className="mb-2">
                                <div className="text-lg">
                                    {overlap.title}
                                </div>
                                <div>
                                    {overlap.passengers ? `${overlap.passengers}: ` : ""}{overlap.date} {overlap.time}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="my-4">
                        <Trans id="continue_adding_item">Do you wish to continue with adding the selected item?</Trans>
                    </div>
                </div>
            </div>

            <ModalFooter
                onCancel={onCancel}
                actionDisabled={confirmDisabled}
                actionButtonText={t({id: "confirm"})}
                onActionClick={onConfirm}
            />
        </>
    );
}

export default OverlapWarning;
